<template>
  <el-col :span="widgetConfig.span || 24" :class="widgetConfig.columnName === 'data_43' || widgetConfig.columnName === 'data_35' ? 'number' : ''">
    <!-- 表单输入组件 -->
    <template v-if="widgetConfig.widgetKind === SysCustomWidgetKind.Form">
      <!-- 只读或者文本字段 -->
      <template v-if="widgetConfig.widgetType === SysCustomWidgetType.Label ||
        widgetConfig.readOnly
        ">
        <el-form-item :class="widgetConfig.columnName === 'data_71' || widgetConfig.columnName === 'data_13' || widgetConfig.columnName === 'data_14' || widgetConfig.columnName === 'data_15' || widgetConfig.columnName === 'remark' ? 'textarea' : '' " :label="widgetConfig.showName + (widgetConfig.showName ? ' :' : '')"
          :style="widgetConfig.columnName === 'data_15' || widgetConfig.columnName === 'data_14' ? 'text-align:right;padding-right:10%' : ''">
          <span v-if="widgetConfig.columnName === 'is_supplementary_agreement'">
            <div style="display: flex;">
              <el-checkbox :value="!!formData.is_supplementary_agreement" disabled></el-checkbox>
              <span class="flow_text" style="margin-left: 15px;" v-if="!!formData.is_supplementary_agreement">
                {{ contractName }}
              </span>
            </div>
          </span>
          <span v-else-if="widgetConfig.columnName === 'invoice_type'" style="display: flex;align-items: center;">
            <el-radio-group v-model="value" disabled style="width: 500px">
              <el-radio :label="1">增值税专用发票</el-radio>
              <el-radio :label="2">增值税普通发票</el-radio>
              <el-radio :label="3">其他</el-radio>
            </el-radio-group>
            <span class="flow_text" v-if="value === 3" style="margin-left: 15px;">
              {{ formData.invoice_type_other || formData.contract__invoice_type_other }}
            </span>
          </span>
          <span class="flow_text" v-else-if="widgetConfig.widgetType === SysCustomWidgetType.Label ||
            widgetConfig.widgetType === SysCustomWidgetType.NumberInput ||
            widgetConfig.widgetType === SysCustomWidgetType.Input ||
            widgetConfig.widgetType === SysCustomWidgetType.Date
            ">
            {{ showText(value) }}
          </span>
          <span class="flow_text"  v-else-if="widgetConfig.widgetType === SysCustomWidgetType.Select">{{ dropdownShowName || value }}</span>
          <span class="flow_text"  v-else-if="widgetConfig.widgetType === SysCustomWidgetType.Cascader">{{ dropdownShowName }}</span>
          <div v-else-if="widgetConfig.widgetType === SysCustomWidgetType.RichEditor
            " v-html="value" />
          <span v-else-if="widgetConfig.widgetType === SysCustomWidgetType.Switch">{{ value ? "是" : "否" }}</span>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item :label="widgetConfig.showName + (widgetConfig.showName ? ' :' : '')" :prop="(widgetConfig.relation
            ? widgetConfig.relation.variableName + '__'
            : '') + (widgetConfig.column || {}).columnName
          ">
          <div v-if="widgetConfig.columnName == 'data_14'" style="text-align:right">
            整改负责人:
            <el-input style="width:150px" clearable :type="widgetConfig.type" :autosize="{
              minRows: widgetConfig.minRows || 1,
              maxRows: widgetConfig.maxRows || 1,
            }" :disabled="widgetConfig.disabled" :value="value" @input="handlerWidgetInput"
              :placeholder="widgetConfig.placeholder" />
          </div>
          <div v-else-if="widgetConfig.columnName == 'data_13'">
            <el-input clearable :type="widgetConfig.type" class="hidden_trouble" :autosize="{
              minRows: widgetConfig.minRows || 1,
            }" :disabled="widgetConfig.disabled" :value="value" @input="handlerWidgetInput"
              :placeholder="widgetConfig.placeholder" />
          </div>
          <!-- invoice_name -->
          <template v-else-if="widgetConfig.widgetType === SysCustomWidgetType.Input">
            <template v-if="widgetConfig.columnName == 'invoice_name'">
              <div style="display: flex;">
                <el-input style="flex: 1;" class="input-class" clearable :type="widgetConfig.type" :disabled="widgetConfig.disabled" :value="value" @input="handlerWidgetInput" :placeholder="widgetConfig.placeholder" />
                <el-button v-if="!widgetConfig.readOnly && $route.query.formId === '2074057795207958528'" style="margin-left: 15px;" type="primary" @click="handleAddInvoice">添加</el-button>
              </div>
            </template>
            <template v-else-if="widgetConfig.columnName == 'contract_name'&& $route.query.formId === '2074057795207958528'">
              <el-input class="input-class" clearable :type="widgetConfig.type" :autosize="{   minRows: widgetConfig.minRows || 1,   maxRows: widgetConfig.maxRows || 1, }" :disabled="widgetConfig.disabled" :value="value" @input="handlerWidgetInput" :placeholder="widgetConfig.placeholder" />
              <div style="color:red">示例：乙方公司名-材料名称</div>
            </template>
            <el-input v-else class="input-class" clearable :type="widgetConfig.type" :autosize="{   minRows: widgetConfig.minRows || 1,   maxRows: widgetConfig.maxRows || 1, }" :disabled="widgetConfig.disabled" :value="value" @input="handlerWidgetInput" :placeholder="widgetConfig.placeholder" />
          </template>
          <template v-if="widgetConfig.widgetType === SysCustomWidgetType.NumberInput">
            <template v-if="widgetConfig.columnName == 'is_supplementary_agreement'">
              <div style="display: flex;">
                <el-checkbox :key="value" :checked="value" :disabled="widgetConfig.disabled" @change="handlerWidgetInput"></el-checkbox>
                <el-select :key="formData.project_id" v-if="value && formData.project_id" :value="formData.contract_id" style="flex:1;margin-left: 20px;" placeholder="请选择原合同" filterable @change="handleChangeContract">
                  <el-option v-for="item in contractList" :key="item.id" :value="item.id" :label="item.contractName" />
                </el-select>
              </div>
            </template>
            <template v-else-if="widgetConfig.columnName === 'invoice_type'">
              <div style="display: flex;align-items: center;">
                <el-radio-group v-model="value" :disabled="widgetConfig.disabled" @change="handlerWidgetInput">
                  <el-radio :label="1">增值税专用发票</el-radio>
                  <el-radio :label="2">增值税普通发票</el-radio>
                  <el-radio :label="3">其他</el-radio>
                </el-radio-group>
                <el-input style="margin-left: 10px;flex: 1" v-if="value === 3" class="input-item" clearable
                  :disabled="widgetConfig.disabled" :value="formData.invoice_type_other || formData.contract__invoice_type_other" @input="handlerInputOther"
                  placeholder="请输入" />
              </div>
            </template>
            <template v-else-if="widgetConfig.columnName === 'cumulative_amount'">
              {{ formData.is_supplementary_agreement ? ((value || 0) + (formData.contract_amount || 0)).toFixed(2) : 0 }}
            </template>
            <el-input-number v-else class="input-item" clearable
              :disabled="widgetConfig.disabled" :min="widgetConfig.min" :max="widgetConfig.max" :step="widgetConfig.step"
              :precision="widgetConfig.precision" :controls='false' :value="value" @input="handlerWidgetInput"
              :placeholder="widgetConfig.placeholder" />
          </template>
          <el-select v-if="widgetConfig.widgetType === SysCustomWidgetType.Select" class="input-item" :clearable="widgetConfig.columnName !== 'qj_date'" filterable
            :disabled="widgetConfig.disabled" :value="value" @input="handlerWidgetInput"
            :placeholder="widgetConfig.placeholder" :loading="dropdownWidget.loading" @visible-change="(isShow) =>
                dropdownWidget.onVisibleChange(isShow).catch((e) => { })
              " @change="handlerWidgetChange" :key="widgetConfig.columnName === 'supplier_name' ? supplierList.length : widgetConfig.columnName">
            <template v-if="widgetConfig.columnName == 'data_233' || widgetConfig.columnName == 'project_name'">
              <el-option v-for="(item,index) in proList" :key="item.id" :value="item.project_name" :label="item.project_name" />
            </template>
            <template v-else-if="widgetConfig.columnName == 'supplier_name'">
              <el-option v-for="item in supplierList" :key="item.id + '_' + supplierList.length" :value="item.name" :label="item.name" />
            </template>
            <template v-else-if="widgetConfig.columnName == 'qj_date'">
              <el-option v-for="item in qjList" :key="item.id" :value="item.date" :label="item.date" />
            </template>
            <template v-else-if="widgetConfig.columnName == 'data_252'">
              <el-option v-for="item in contractList" :key="item.id" :value="item.id" :label="item.contract_name" />
            </template>
            <template v-else-if="widgetConfig.columnName == 'contract_id'">
              <el-option v-for="item in contractList" :key="item.id" :value="item.id" :label="item.contractName" />
            </template>
            <template v-else>
              <el-option v-for="item in dropdownWidget.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </template>
          </el-select>
          <el-cascader v-if="widgetConfig.widgetType === SysCustomWidgetType.Cascader" class="input-item" filterable
            :options="dropdownWidget.dropdownList" :value="cascaderValue" @input="handlerWidgetInput" :clearable="true"
            :show-all-levels="false" :placeholder="widgetConfig.placeholder"
            :props="{ value: 'id', label: 'name', checkStrictly: true }" @visible-change="(isShow) =>
                dropdownWidget.onVisibleChange(isShow).catch((e) => { })
              " @change="handlerWidgetChange" />
          <div v-if="widgetConfig.widgetType === SysCustomWidgetType.Date && widgetConfig.columnName == 'data_9'">
            接此通知后限于
            <el-date-picker style="width:150px !important;" :format="widgetConfig.format || 'yyyy-MM-dd'"
              :value-format="widgetConfig.valueFormat || 'yyyy-MM-dd 00:00:00'" class="input-item" clearable
              :type="widgetConfig.type || 'date'" align="left" :disabled="widgetConfig.disabled" :value="value"
              @input="handlerWidgetInput" :placeholder="widgetConfig.placeholder"
              @change="handlerWidgetChange" />前整改，并将整改内容以影像资料形式后附于回复单提交；如未在限定时间内整改完毕将对整改项目部及相关责任人进行经济处罚，并持续整改。
          </div>
          <div v-else-if="widgetConfig.columnName == 'data_71'">
            根据
            <el-date-picker style="width:150px !important;" :format="widgetConfig.format || 'yyyy-MM-dd'"
              :value-format="widgetConfig.valueFormat || 'yyyy-MM-dd 00:00:00'" class="input-item" clearable
              :type="widgetConfig.type || 'date'" align="left" :disabled="widgetConfig.disabled" :value="value"
              @input="handlerWidgetInput" :placeholder="widgetConfig.placeholder" @change="handlerWidgetChange" />
            公司质安科组现场质量安全检查，我项目部就检查意见进行整改完成（逐条对应写明）：
          </div>
          <div v-else-if="widgetConfig.columnName == 'data_15'" style="text-align:right">
            日期:
            <el-date-picker style="width:150px !important;" :format="widgetConfig.format || 'yyyy-MM-dd'"
              :value-format="widgetConfig.valueFormat || 'yyyy-MM-dd 00:00:00'" class="input-item" clearable
              :type="widgetConfig.type || 'date'" align="left" :disabled="widgetConfig.disabled" :value="value"
              @input="handlerWidgetInput" :placeholder="widgetConfig.placeholder" @change="handlerWidgetChange" />
          </div>
          <el-date-picker v-else-if="widgetConfig.widgetType === SysCustomWidgetType.Date"
            :format="widgetConfig.format || 'yyyy-MM-dd'"
             v-model="startDate"
            :value-format="widgetConfig.valueFormat || 'yyyy-MM-dd 00:00:00'" class="input-item" clearable
            :type="widgetConfig.type || 'date'" align="left" :disabled="widgetConfig.disabled" :value="value"
            @input="handlerWidgetInput" :placeholder="widgetConfig.placeholder"
            :picker-options="widgetConfig.columnName === 'xj_start_time'|| widgetConfig.columnName === 'xj_end_time' ? pickOpt : widgetConfig.columnName === 'replace_time' || widgetConfig.columnName === 'start_time'|| widgetConfig.columnName === 'end_time' ? pickerOptions : {}"
            @change="handlerWidgetChange" />
          <rich-editor v-if="widgetConfig.widgetType === SysCustomWidgetType.RichEditor" class="input-item" :value="value"
            @input="handlerWidgetInput" />
          <el-switch v-if="widgetConfig.widgetType === SysCustomWidgetType.Switch" class="input-item" :value="value"
            @input="handlerWidgetInput" />
        </el-form-item>
      </template>
    </template>
    <!-- 数据展示组件 -->
    <template v-else-if="widgetConfig.widgetKind === SysCustomWidgetKind.Data">
      <el-divider v-if="widgetConfig.widgetType === SysCustomWidgetType.Divider"
        :content-position="widgetConfig.position">
        {{ widgetConfig.showName }}
      </el-divider>
      <CustomText v-else-if="widgetConfig.widgetType === SysCustomWidgetType.Text" :widgetConfig="widgetConfig" />
      <CustomImage v-else-if="widgetConfig.widgetType === SysCustomWidgetType.Image" :widgetConfig="widgetConfig" />
    </template>
    <!-- 容器组件 -->
    <template v-else-if="widgetConfig.widgetKind === SysCustomWidgetKind.Container">
      <el-card v-if="widgetConfig.widgetType === SysCustomWidgetType.Card" class="base-card" :shadow="widgetConfig.shadow"
        :body-style="{
          padding: widgetConfig.padding ? widgetConfig.padding + 'px' : '0px',
        }" :style="{
  height:
    widgetConfig.height != null && widgetConfig.height !== ''
      ? widgetConfig.height + 'px'
      : undefined,
  'margin-bottom':
    widgetConfig.supportBottom === 1 ? '20px' : undefined,
}">
        <div slot="header" class="base-card-header">
          <span>{{ widgetConfig.showName }}</span>
        </div>
        <el-row :gutter="widgetConfig.gutter">
          <slot></slot>
        </el-row>
      </el-card>
    </template>
    <supplier-dialog :visible.sync="supplierDialogVisible" @success="onSupplierAdded" />
  </el-col>
</template>

<script>
import { DropdownWidget } from '@/utils/widget.js';
import { OnlineOperation } from '@/api/onlineController.js';
import { getDictDataList } from '../utils';
import {
  findItemFromList,
  findTreeNodePath,
  findTreeNodeObjectPath
} from '@/utils';
import CustomText from './customText.vue';
import CustomImage from './customImage.vue';
import SupplierDialog from './supplierDialog.vue';
import { Contract } from '@/api/contract';
import { Attendance } from '@/api/attendance'

export default {
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    widgetConfig: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: () => {}
    },
    value: {
      type: [String, Number, Date, Object, Array, Boolean]
    },
    getDropdownParams: {
      type: Function
    },
    projectName: {
      type: String,
      default: ''
    }
  },
  inject: ['preview'],
  components: {
    CustomText,
    CustomImage,
    SupplierDialog
  },
  data() {
    var _this = this
    return {
      pickerOptions: {
        disabledDate(time) {
          if (_this.widgetConfig.columnName === 'replace_time') {
            return time.getTime() > Date.now();
          } else {
            var date = new Date(_this.setDate(Date.now())[1]);
            return time.getTime() > date
          }
        }
      },
      pickOpt: {},
      startTime: {
        disabledDate(time) {
          return time.getDay() == 6 || time.getDay() == 0
        }
      },
      cascaderValue: [],
      dropdownWidget:
        this.widgetConfig.widgetType === this.SysCustomWidgetType.Select ||
          this.widgetConfig.widgetType === this.SysCustomWidgetType.Cascader
          ? new DropdownWidget(
            this.loadDropdwonList,
            this.widgetConfig.widgetType === this.SysCustomWidgetType.Cascader
          )
          : undefined,
      proList: [],
      contractList: [],
      qjList: [],
      data:{},
      startDate: '',
      supplierList: [],
      lastProjectId: null,
      lastSupplierId: null,
      supplierDialogVisible: false,
      contractName: null,
      isRuntime: this.$route.query.isRuntime || false
    };
  },
  watch: {
    projectName(val) {
      if (this.widgetConfig.columnName === 'data_252') {
        this.getContract(val)
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if(this.widgetConfig.widgetType === 20) this.startDate = val
        if (this.widgetConfig.columnName === 'xj_start_date' && this.widgetConfig.readOnly) {
          this.getQjList(true, val)
        }
        if (this.widgetConfig.columnName === 'is_supplementary_agreement' && this.widgetConfig.readOnly && val) {
          OnlineOperation.listDict(this, {
            dictId: '2066344205160026112'
          }).then(res => {
            const contractList = res.data
            const info = contractList.find(item => item.id === this.formData.contract_id)
            this.contractName = info.name
          })
        }
      }
    },
    formData: {
      deep: true,
      immediate: true,
      handler (val) {
        localStorage.setItem('form', JSON.stringify(val))
        if (this.widgetConfig.columnName === 'is_supplementary_agreement' && val.is_supplementary_agreement && val.project_id && val.project_id !== this.lastProjectId) {
          if (!this.widgetConfig.readOnly) {
            this.lastProjectId = val.project_id
            if (this.isRuntime) {
              this.isRuntime = false
            } else {
              this.contractList = []
              this.$emit('setFormData', null, 'contract_id');
              this.resetContract()
            }
            Contract.getContractListByProjectId(this, {
              projectId: val.project_id
            }).then(res => {
              this.contractList = [...res.data]
            })
          }
        }

        if ((this.$route.query.formId === '2074073417283276800' || this.$route.query.formId === '2074075327247683584') && this.widgetConfig.columnName === 'contract_id' && val.project_id && val.project_id !== this.lastProjectId) {
          if (!this.widgetConfig.readOnly) {
            this.lastProjectId = val.project_id
            if (this.isRuntime) {
              this.isRuntime = false
            } else {
              this.contractList = []
              this.$emit('setFormData', null, 'contract_id');
            }
            Contract.getContractListByProjectId(this, {
              projectId: val.project_id
            }).then(res => {
              this.contractList = res.data.filter(item => !item.finalSettlementAmount)
            })
          }
        }
        if (this.widgetConfig.columnName === 'supplier_name') {
          OnlineOperation.listDict(this, {
            dictId: '2064602753610551296'
          }).then(res => {
            this.supplierList = [...res.data]
          })
        }
        if((this.widgetConfig.readOnly || this.$route.query.flowStatus === '未办结') && this.widgetConfig.columnName === 'data_253'){
           this.$emit('change', 0, {}, {}, 'money')
        }
        this.data = val
        let that = this
        let time = '00:00:00 - 23:59:59'
        if (this.widgetConfig.columnName === 'xj_start_time' || this.widgetConfig.columnName === 'xj_end_time') {
          let str = ''
          for(var key in that.data){
            if(key.indexOf('oaFlowXjsq') === 0){
              str = key.split('__')[0]
              break
            }
          }
          if(this.widgetConfig.columnName === 'xj_start_time' && str && that.data[str+'__start_time']) time =that.data[str+'__start_time'].split(' ')[1] + " - 23:59:59"
          if(this.widgetConfig.columnName === 'xj_end_time' && str && that.data[str+'__end_time']) time ="00:00:00 - " + that.data[str+'__end_time'].split(' ')[1]
          this.pickOpt = {
           disabledDate(time) {
              if(that.data[str+'__start_time'] && that.data[str+'__end_time']){
                var time1 = (new Date(that.data[str+'__start_time'])).getTime();
                var time2 = (new Date(that.data[str+'__end_time'])).getTime();
                let number = 0
                if(that.data[str+'__start_time'].split(' ')[1] !== '00:00:00')  number = 24 * 3600000
                return time.getTime() + number < time1 || time.getTime() > time2
              }
              return true
           },
           selectableRange: time
        }
        }

      }
    },
    startDate: {
      deep: true,
      immediate: true,
      handler(val) {
        let time = ''
          let str = ''
          for(var key in this.data){
            if(key.indexOf('oaFlowXjsq') === 0){
              str = key.split('__')[0]
              break
            }
          }
          if(this.widgetConfig.columnName === 'xj_start_time' && str && this.data[str+'__start_time']){
             time =this.data[str+'__start_time'].split(' ')[1] + " - 23:59:59"
             if(val.split(' ')[0] === this.data[str+'__start_time'].split(' ')[0]) this.pickOpt.selectableRange = time
             if(val.split(' ')[0] === this.data[str+'__end_time'].split(' ')[0]) this.pickOpt.selectableRange = "00:00:00 - " + this.data[str+'__end_time'].split(' ')[1]
          }
          if(this.widgetConfig.columnName === 'xj_end_time' && str && this.data[str+'__end_time']){
             time ="00:00:00 - " + this.data[str+'__end_time'].split(' ')[1]
             if(val.split(' ')[0] === this.data[str+'__start_time'].split(' ')[0]) this.pickOpt.selectableRange = this.data[str+'__start_time'].split(' ')[1] + " - 23:59:59"
             if(val.split(' ')[0] === this.data[str+'__end_time'].split(' ')[0]) this.pickOpt.selectableRange = time
          }
      }
    }
  },
  created() {
    if (this.widgetConfig.columnName === 'data_233' || this.widgetConfig.columnName === 'project_name') {
      this.getWidgetList()
    }
    if (this.widgetConfig.columnName === 'qj_date') this.getQjList()
    if (this.widgetConfig.columnName === 'supplier_name') {
      OnlineOperation.listDict(this, {
        dictId: '2064602753610551296'
      }).then(res => {
        this.supplierList = res.data
      })
    }
    if (this.widgetConfig.columnName === 'is_supplementary_agreement') {

      const data = JSON.parse(localStorage.getItem(this.$route.query.processDefinitionKey))
      
      if (this.$route.query.processDefinitionKey === '发起人' && !data) this.lastProjectId = this.formData.project_id

      if (!data) return

      this.lastProjectId = data.project_id

      if (data.is_supplementary_agreement && this.lastProjectId) {
        this.$nextTick(() => {
          Contract.getContractListByProjectId(this, {
            projectId: data.project_id
          }).then(res => {
            this.contractList = res.data.filter(item => !item.finalSettlementAmount)
          })
        })
      }
    }
    
    if ((this.$route.query.formId === '2074073417283276800' || this.$route.query.formId === '2074075327247683584') && this.widgetConfig.columnName === 'contract_id') {
      const data = JSON.parse(localStorage.getItem(this.$route.query.processDefinitionKey))
      this.lastProjectId = data.project_id
      if (this.lastProjectId) {
        this.$nextTick(() => {
          Contract.getContractListByProjectId(this, {
            projectId: data.project_id
          }).then(res => {
            this.contractList = res.data.filter(item => !item.finalSettlementAmount)
          })
        })
      }
    }
  },
  methods: {
    handleAddInvoice() {
      this.supplierDialogVisible = true
    },
    onSupplierAdded (data) {
      this.getSupplierInfo(data.data)
    },
    setDate(date){
      let curDate = new Date(date)
      let y = curDate.getFullYear();
      let m = curDate.getMonth() + 2; // 本身就得+1才等于当前月份，然而我要计算下一个月，所以直接+2
      if (m == 13) {
       m = 1;
       y++
      }
      let monthLastDay = new Date(y, m, 0).getDate();
      return [y + '-' + (m < 10 ? '0' + m : m) + '-' + '01', y + '-' + (m < 10 ? '0' + m : m) + '-' + (monthLastDay < 10 ? '0' + monthLastDay : monthLastDay)]
    },
    showText(value) {
      if (this.widgetConfig.columnName === 'data_9') {
        return '接此通知后限于' + (value ? value : '') + '前整改，并将整改内容以影像资料形式后附于回复单提交；如未在限定时间内整改完毕将对整改项目部及相关责任人进行经济处罚，并持续整改。'
      } else if (this.widgetConfig.columnName === 'data_71') {
        return '根据' + (value ? value : '') + '公司质安科组现场质量安全检查，我项目部就检查意见进行整改完成（逐条对应写明）：'
      } else if (this.widgetConfig.columnName === 'data_15') {
        return '日期 : ' + (value ? value : '')
      } else if (this.widgetConfig.columnName === 'data_14') {
        return '整改负责人 : ' + (value ? value : '')
      } else {
        return value
      }
    },
    getWidgetList() {
      const info = JSON.parse(localStorage.getItem('userInfo')).data
      if (this.widgetConfig.columnName === 'data_233') {
        if(info.deptId != 13 && info.deptId != 11 || info.userId == 224){
        Contract.getProjectAllList(this,{}).then(res => {
          this.proList = res.data.dataList.map(item => {
            const obj = {}
            for (var str in item) {
              let newStr = str.split(/(?=[A-Z])/)
              newStr.map(name => name.toLowerCase())
              const key = newStr.map(name => name.toLowerCase()).join('_')
              obj[key] = item[str]
            }
            return obj
          })
        })
        }else{
        Contract.getProjectAll(this, {
          userId: info.userId
        }).then(res => {
          this.proList = res.data.dataList.map(item => {
            const obj = {}
            for (var str in item) {
              let newStr = str.split(/(?=[A-Z])/)
              newStr.map(name => name.toLowerCase())
              const key = newStr.map(name => name.toLowerCase()).join('_')
              obj[key] = item[str]
            }
            return obj
          })
        })
        }
      }
      if (this.widgetConfig.columnName === 'project_name' && !this.widgetConfig.readOnly) {
        
        if (info.deptId != 13 && info.deptId != 11) {
          Contract.getContractProjectList(this, {}).then(res => {
            this.proList = res.data.dataList.map(item => {
              const obj = {}
              for (var str in item) {
                let newStr = str.split(/(?=[A-Z])/)
                newStr.map(name => name.toLowerCase())
                const key = newStr.map(name => name.toLowerCase()).join('_')
                obj[key] = item[str]
              }
              return obj
            })
          })
        }else{
          Contract.getProjectAll(this, {
            userId: info.userId
          }).then(res => {
            this.proList = res.data.dataList.map(item => {
              const obj = {}
              for (var str in item) {
                let newStr = str.split(/(?=[A-Z])/)
                newStr.map(name => name.toLowerCase())
                const key = newStr.map(name => name.toLowerCase()).join('_')
                obj[key] = item[str]
              }
              return obj
            })
          })
        }
      }
    },
    getQjList(flag, val) {
      if (this.widgetConfig.columnName !== 'qj_date') return
      Attendance.getQjList(this).then(res => {
        this.qjList = res.data.map(item => {
          const obj = {}
          item.date = item.startTime.split(' ')[0]
          for (var str in item) {
            let newStr = str.split(/(?=[A-Z])/)
            newStr.map(name => name.toLowerCase())
            const key = newStr.map(name => name.toLowerCase()).join('_')
            obj[key] = item[str]
          }
          return obj
        })
        if (flag) {
          const obj = this.qjList.find(item => item.date === val)
          this.$emit('change', 0, this.widgetConfig, obj, 'xj');
        }
      })
    },
    getContract(project_name) {
      Contract.getContractList(this, {
        oaFormContractDto: {
          projectName: project_name,
        }
      }).then(rs => {
        this.contractList = rs.data.dataList.map(item => {
          const obj = {}
          for (var str in item) {
            let newStr = str.split(/(?=[A-Z])/)
            newStr.map(name => name.toLowerCase())
            const key = newStr.map(name => name.toLowerCase()).join('_')
            obj[key] = item[str]
          }
          return obj
        })
      })
    },
    reset() {
      this.handlerWidgetInput(undefined);
      this.cascaderValue = [];
      if (this.dropdownWidget) this.dropdownWidget.dirty = true;
    },
    loadDropdwonList() {
      if (this.preview()) {
        return Promise.resolve([]);
      }
      return new Promise((resolve, reject) => {
        if (
          this.widgetConfig.column != null &&
          this.widgetConfig.column.dictInfo != null
        ) {
          let params = {};
          let dictInfo = this.widgetConfig.column.dictInfo;
          if (
            dictInfo.dictType === this.SysOnlineDictType.TABLE ||
            dictInfo.dictType === this.SysOnlineDictType.URL
          ) {
            params = this.getDropdownParams
              ? this.getDropdownParams(this.widgetConfig)
              : {};
          }
          if (params == null) {
            reject();
          } else {
            getDictDataList(this, dictInfo, params)
              .then((res) => {
                resolve(res);
              })
              .catch((e) => {
                reject(e);
              });
          }
        } else {
          reject();
        }
      });
    },
    getDropdownImpl() {
      return this.dropdownWidget;
    },
    onVisibleChange() {
      if (this.dropdownWidget) {
        this.dropdownWidget.onVisibleChange(true).then((res) => {
          // 级联组件获取下拉数据，计算组件显示path
          if (
            this.widgetConfig.widgetType === this.SysCustomWidgetType.Cascader
          ) {
            this.cascaderValue = findTreeNodePath(res, this.value, 'id');
          }
        });
      }
    },
    handlerWidgetInput(value) {
      const formIdList = ['1635116863346184192','1632914841112940544','1630054016488574976','1635508544616796160']
      if( formIdList.indexOf(this.$route.query.formId) !== -1){
        if( this.widgetConfig.variableName === 'data45') this.$emit('changeAmount', value,'data_60');
        if( this.widgetConfig.variableName === 'data254') this.$emit('changeAmount', value,'data_282');
        if( this.widgetConfig.variableName === 'payment') this.$emit('changeAmount', value,'big_pay_money');
        if( this.widgetConfig.variableName === 'income') this.$emit('changeAmount', value,'big_in_money');
        if( this.widgetConfig.variableName === 'data275') this.$emit('changeAmount', value,'total_big_money');
        if( this.widgetConfig.variableName === 'data200') this.$emit('changeAmount', value,'data_251');
      }

      if (this.widgetConfig.variableName === 'supplierName') {
        const supplierId = this.supplierList.find(item => item.name === value)?.id;
        this.getSupplierInfo(supplierId)
        return
      }
      if (this.widgetConfig.widgetType === this.SysCustomWidgetType.Cascader) {
        this.cascaderValue = value;
        if (Array.isArray(value) && value.length > 0) {
          this.$emit('input', value[value.length - 1], this.widgetConfig);
        } else {
          this.$emit('input', undefined, this.widgetConfig);
        }
      } else {
        if(this.widgetConfig.columnName === 'invoice_type') {
          this.$emit('setFormData', null, 'invoice_type_other');
        }
        if(this.widgetConfig.columnName === 'project_name') {
          let proId = null
          let nature = null
          this.proList.forEach((item) => {
            if (item.project_name === value) {
              proId = item.id
              nature = item.project_nature
            }
          });
          this.$emit('setFormData', proId, 'project_id');
          this.$emit('setFormData', nature, 'project_nature');
          this.$emit('setFormData', nature, 'projectNature');
        }
        
        this.$emit('input', value, this.widgetConfig);
        if (this.widgetConfig.columnName === 'is_supplementary_agreement' && !value) {
          console.log(555666);
          
          this.$emit('setFormData', null, 'contract_id');
          this.resetContract()
        }
      }
    },
    getSupplierInfo (id) { 
      Contract.getSupplierById(this, {
        id
      }).then(res => {
        const data= res.data || {}
        this.$emit('setFormData', data.id, 'supplier_id');
        this.$emit('setFormData', data.companyName, 'supplier_name');
        this.$emit('setFormData', data.kaipiaoName, 'invoice_name');
        this.$emit('setFormData', data.nashuiNumber, 'taxpayer_id');
        this.$emit('setFormData', data.kaipiaoAddress, 'invoice_address_phone');
        this.$emit('setFormData', data.bank, 'bank_name');
        this.$emit('setFormData', data.bankNumber, 'bank_account');
      })
    },
    resetContract () {
      console.log(55555);
      
      this.$emit('setFormData', null, 'supplier_id');
      this.$emit('setFormData', null, 'supplier_name');
      this.$emit('setFormData', null, 'invoice_name');
      this.$emit('setFormData', null, 'taxpayer_id');
      this.$emit('setFormData', null, 'invoice_address_phone');
      this.$emit('setFormData', null, 'bank_name');
      this.$emit('setFormData', null, 'bank_account');
    },
    handlerInputOther(value) {
      this.$emit('setFormData', value, 'invoice_type_other');
    },
    handleChangeContract(value) {
      this.$emit('setFormData', value, 'contract_id');
      const info = this.contractList.find(item => item.id === value)
      if (value) {
        Contract.sumContractAmount(this, { contractId: value }).then(res => {
          this.$emit('setFormData', res.data, 'cumulative_amount');
        });
      }
      this.getSupplierInfo(info.supplierId)
    },
    handlerWidgetChange(value) {
      if (this.widgetConfig.widgetType === this.SysCustomWidgetType.Cascader) {
        if (Array.isArray(value) && value.length > 0) {
          this.$emit('change', value[value.length - 1], this.widgetConfig);
        } else {
          this.$emit('change', undefined, this.widgetConfig);
        }
      } else {

        let objArr = [];
        let type = ''
        if (this.widgetConfig.columnName == 'data_233') {
          type = 'project'
          objArr = this.proList.filter((item) => {
            if (item.project_name === value) {
              return item;
            }
          });
        } else if (this.widgetConfig.columnName == 'data_252') {
          type = 'contract'
          objArr = this.contractList.filter((item) => {
            if (item.id === value) {
              return item;
            }
          });
        }else if (this.widgetConfig.columnName == 'start_time' || this.widgetConfig.columnName == 'xj_start_time') {
          type = 'start'
        } else if (this.widgetConfig.columnName == 'end_time' || this.widgetConfig.columnName == 'xj_end_time') {
          type = 'end'
        } else if (this.widgetConfig.columnName == 'qj_date') {
          type = 'xj'
          objArr = this.qjList.filter(item => item.date === value)
        }
        if(this.$route.query.flowEntryName ==="补卡申请" && this.widgetConfig.columnName === 'replace_time'){
          type = 'replace_time'
        }
        if ((this.$route.query.flowEntryName === "合同作废" || this.$route.query.flowEntryName === "合同终止") && this.widgetConfig.columnName === 'contract_id') {
          this.$emit('setFormData', value, 'contract_id');
          const info = this.contractList.find(item => item.id === value)
          this.$nextTick(() => {
            this.$emit('setFormData', info.contractName, 'contract_name');
            this.$emit('setFormData', info.contractNo, 'contract__contract_no');
            this.$emit('setFormData', info.contractType, 'contract__contract_type');
            this.$emit('setFormData', info.materialName, 'contract__material_name');
            this.$emit('setFormData', info.supplierId, 'supplier_id');
            this.$emit('setFormData', info.supplierName, 'contract__supplier_name');
            this.$emit('setFormData', info.invoiceName, 'contract__invoice_name');
            this.$emit('setFormData', info.taxpayerId, 'contract__taxpayer_id');
            this.$emit('setFormData', info.invoiceAddressPhone, 'contract__invoice_address_phone');
            this.$emit('setFormData', info.bankName, 'contract__bank_name');
            this.$emit('setFormData', info.bankAccount, 'contract__bank_account');
            this.$emit('setFormData', info.invoiceType, 'contract__invoice_type');
            this.$emit('setFormData', info.invoiceTypeOther, 'contract__invoice_type_other');
            this.$emit('setFormData', info.projectNature, 'contract__project_nature');
          })
          return
        }
        this.$emit('change', value, this.widgetConfig, objArr[0], type);
      }
    },
    // 获得字典值
    getDictValue(id) {
      if (
        this.dropdownWidget &&
        Array.isArray(this.dropdownWidget.dropdownList)
      ) {
        return (
          findItemFromList(this.dropdownWidget.dropdownList, id, 'id') || {}
        ).name;
      }

      return id;
    },
    getTreeDictValue(id) {
      if (
        this.dropdownWidget &&
        Array.isArray(this.dropdownWidget.dropdownList)
      ) {
        let nodePath = findTreeNodeObjectPath(
          this.dropdownWidget.dropdownList,
          id,
          'id'
        );
        if (Array.isArray(nodePath)) {
          return nodePath.map((item) => item.name).join(' / ');
        }
      }

      return id;
    }
  },
  computed: {
    dropdownShowName() {
      if (
        this.dropdownWidget &&
        Array.isArray(this.dropdownWidget.dropdownList)
      ) {
        if (this.widgetConfig.widgetType === this.SysCustomWidgetType.Select) {
          if (this.widgetConfig.columnName === 'data_233' || this.widgetConfig.columnName === 'data_252') {
            return this.value
          } else {
            return this.getDictValue(this.value);
          }
        } else if (
          this.widgetConfig.widgetType === this.SysCustomWidgetType.Cascader
        ) {
          return this.getTreeDictValue(this.value);
        }
      }
      return this.value;
    }
  },
  mounted() {
    this.onVisibleChange();
  }
};
</script>

<style lang="scss">
.text_show {
  white-space: pre-line;
}
.textarea{
  .flow_text{
    border:none;
    display:inline;
    word-wrap: anywhere;
  }
}
.flow_text{
  display: inline-block;
  width: 100%;
  border: 1px solid #dedede;
  min-height: 30px;
  border-radius: 3px;
  padding-left: 10px;
  word-wrap: anywhere;
}
</style>
